<template>
  <v-dialog v-model="show" persistent width="900">
    <v-card :loading="loading">
      <v-card-title>Product transaction error for {{info.bonded ? 'in-bond' : 'duty-paid'}} {{name}}</v-card-title>
      <v-divider/>
      <v-card-text>
        <div class="error--text pa-2 text-body-1">{{error.message}}</div>

        <v-simple-table fixed-header height="300">
          <thead>
            <tr>
              <th width="20%">Date</th>
              <th width="40%">Transaction</th>
              <th width="20%" class="text-right">
                <template v-if="info.quantity">
                  <v-select :items="[{text:'Bottles',value:false},{text:'Cases',value:true}]" v-model="cases" class="text-caption"/>
                </template>
                <template v-else>$</template>
              </th>
              <th width="20%" class="text-right">Balance</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(line,index) in lines" :class="{'font-weight-bold':index===1, 'error--text':line.balance<0}">
              <td>{{line.date | formatDateTime}}</td>
              <td>{{line.description}}</td>
              <td class="text-right">
                <template v-if="line.amount !== undefined">
                  <template v-if="info.quantity">
                    {{line.amount/(cases?caseSize:1) | number(cases?1:0)}}
                  </template>
                  <template v-else>{{line.amount | number(2)}}</template>
                </template>
              </td>
              <td class="text-right">
                <template v-if="info.quantity">
                  {{line.balance/(cases?caseSize:1) | number(cases?1:0)}}
                </template>
                <template v-else>{{line.balance | number(2)}}</template>
              </td>
            </tr>
          </tbody>
        </v-simple-table>

      </v-card-text>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="show=false;$emit('done')">Done</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {add,format} from 'date-fns';

export default {
  name: 'InventoryProductsTransactionError',
  data() {
    return {
      show: true,
      name: '',
      cases: false,
      caseSize: 1,
      lines: []
    }
  },
  computed: {
    error() {
      return this.$store.state.error;
    },
    info() {
      return this.error.info;
    }
  },
  async created() {
    this.loading = true;
    const results = await this.$apiCall(`query InventoryProductsTransactionError($id:ID!,$asof:DateTime!) {
                                              product(id:$id) {
                                                name,caseSize,sites(asof:$asof) {lot,siteId,inBondBottles,inBondValue,dutyPaidBottles,dutyPaidValue}
                                                transactions2(first:100, sortKey:"date", reverse:false,
                                                              filters:[{field:"from", comparator:ge, value:"${this.info.transactionDate.substring(0,10)}"},
                                                                      {field:"to", comparator:le, value:"${this.info.errorDate.substring(0,10)}"},
                                                                      {field:"siteId", comparator:eq, value:"${this.info.siteId}"},
                                                                      {field:"lot", comparator:eq, value:"${this.info.lot}"},
                                                                      {field:"bonded", comparator:eq, value:"${this.info.bonded}"}]) {
                                                  edges {
                                                    node {
                                                      refId,date,description,bottles,cases,value
                                                    }
                                                  }
                                                }
                                              }
                                            }`,
                                        {id:this.info.productId,
                                          asof:format(add(new Date(this.info.transactionDate), {seconds:-1}), 'yyyy-MM-dd HH:mm:ss')});
    if (!results.error) {
      const product = results.data.product;
      this.name = product.name;
      this.caseSize = product.caseSize;
      const site = product.sites.find(site => site.siteId === this.info.siteId && site.lot === this.info.lot);
      let balance = site ? site[this.info.quantity ? (this.info.bonded ? 'inBondBottles' : 'dutyPaidBottles') : (this.info.bonded ? 'inBondValue' : 'dutyPaidValue')] : 0;
      this.lines.push({description:'Balance forward',balance});
      balance += this.info.amount;
      this.lines.push({date:this.info.transactionDate,description:'PROPOSED TRANSACTION',amount:this.info.amount,balance});
      for (const edge of product.transactions2.edges) {
        const transaction = edge.node;
        if (transaction.refId === this.info.transactionId  || transaction.date < this.info.transactionDate)
          continue;
        const amount = this.info.quantity ? transaction.bottles : transaction.value;
        balance += amount;
        this.lines.push({date:transaction.date,description:transaction.description,amount,balance});
      }

    }
    this.loading = false;
  }
}
</script>